import { HERO_SWIRL_CLIP_ID, HERO_SWIRL_CLIP_NAV_ID } from '@/constants/heroScene';

import styles from './HeroSwirlCircle.module.css';

/**
 * Full swoosh-circle blob from Figma (`public/svg/hero-swirl-vector.svg`).
 * `HeroSwirl` is the cropped top sliver of this same shape; this path is the
 * complete circle used as a live clip mask on `#introduction` and StickyNav
 * during the hero scroll scene.
 */
export const HERO_SWIRL_CIRCLE_PATH =
  'M1412.84 2272.93C1937.1 2159.28 2206.83 1847.89 2329.43 1585.37C2414.67 1404.67 2426.34 1246.7 2427.51 1197.83C2427.51 1192.15 2427.51 1187.61 2427.51 1181.92C2427.51 529.593 1884.56 0 1213.17 0C1143.11 0 1073.06 5.68232 1006.5 17.047C665.551 80.689 502.083 268.206 370.14 459.132C199.665 706.881 126.104 962.586 126.104 962.586C162.301 695.517 226.521 534.139 366.637 340.939C371.308 335.257 374.81 329.575 379.481 322.756C145.954 538.684 0 844.393 0 1183.06C0 1835.39 542.95 2364.98 1214.34 2364.98C1603.16 2364.98 1948.78 2187.7 2170.63 1910.4C1967.46 2118.37 1677.89 2253.61 1412.84 2272.93ZM2038.69 1862.67C2165.96 1741.06 2241.86 1631.96 2241.86 1631.96C2157.79 1784.25 1963.96 1974.04 1806.33 2055.87C1806.33 2055.87 1911.42 1984.27 2038.69 1862.67Z';

export const HERO_SWIRL_CIRCLE_VIEWBOX = { width: 2427.51, height: 2364.98 } as const;

type HeroSwirlClipDefProps = {
  /** Ref to the intro clipPath `<path>` — GSAP syncs its `transform` per frame. */
  pathRef?: React.Ref<SVGPathElement>;
  /** Ref to the StickyNav clipPath `<path>` — separate local-space transform. */
  navPathRef?: React.Ref<SVGPathElement>;
};

/**
 * Zero-size SVG hosting swirl `<clipPath>` defs for `#introduction` and
 * StickyNav. Must stay in the DOM (not `display: none`) so `clip-path: url(#…)`
 * resolves. Two paths are required because `userSpaceOnUse` is relative to
 * each clipped element's border box.
 */
export function HeroSwirlClipDef({ pathRef, navPathRef }: HeroSwirlClipDefProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      className={styles.clipDef}
    >
      <defs>
        <clipPath id={HERO_SWIRL_CLIP_ID} clipPathUnits="userSpaceOnUse">
          <path ref={pathRef} d={HERO_SWIRL_CIRCLE_PATH} />
        </clipPath>
        <clipPath id={HERO_SWIRL_CLIP_NAV_ID} clipPathUnits="userSpaceOnUse">
          <path ref={navPathRef} d={HERO_SWIRL_CIRCLE_PATH} />
        </clipPath>
      </defs>
    </svg>
  );
}
